// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2196":"ee8b1517","5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"385":"bb2f2d03d25ac7c1","2196":"d468f0a810ab4a88","5443":"c5ae5ea49ec33797","6350":"7944cc724ad8c02a","7856":"751707fea0bfebc0","9352":"83dcdc1ec0d45a78"}[chunkId] + ".js";
};